<ng-container *ngFor="let trust of trustFormArray.controls; index as i">
  <mat-card appearance="outlined" [formGroup]="trust">
    <mat-card-header>
      <mat-card-title>Trust details <small *ngIf="trust.value.trustType">[{{trust.value.trustType | uppercase }}]</small></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row mb-4" *ngIf="trust.value.trustType === 'security-trust'">
        <div class="col-7">
          <h6 class="text-danger">For TBA Bare Trust please enter details using the following pattern: <strong><i>Surname Initials TBA Property Trust.</i></strong> Surname
            and initials will be from the contact details you enter below.</h6>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <mat-form-field appearance="outline">
            <mat-label>Trust name</mat-label>
            <input matInput placeholder="Trust name" formControlName="trustName">
            <mat-error>
              <app-validation-partial
                  [formGroup]="trust"
                  [fieldName]="'trustName'"
              ></app-validation-partial>
            </mat-error>
          </mat-form-field>
          <mat-error *ngIf="trustFormArray?.errors?.noSameValues" style="position: relative; top: -10px">
            <small>Trusts can't have the same name</small>
          </mat-error>
        </div>
        <div class="col-sm-4" *ngIf="trust.value.trustNoABN === false">
          <mat-form-field appearance="outline">
            <mat-label>ABN</mat-label>
            <input matInput placeholder="ABN" formControlName="trustABN">
            <mat-error>
              <app-validation-partial
                  [formGroup]="trust"
                  [fieldName]="'trustABN'"
              ></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <h4>Contact details</h4>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          <mat-form-field appearance="outline">
            <mat-label>Contact name</mat-label>
            <input matInput placeholder="Contact name" formControlName="trustContactName">
            <mat-error>
              <app-validation-partial
                  [formGroup]="trust"
                  [fieldName]="'trustContactName'"
              ></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3">
          <mat-form-field appearance="outline">
            <mat-label>Position</mat-label>
            <input matInput placeholder="Position" formControlName="trustContactPosition">
            <mat-error>
              <app-validation-partial
                  [formGroup]="trust"
                  [fieldName]="'trustContactPosition'"
              ></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3">
          <fmc-sensis-mobile
            [parentFormGroup]="trust"
            [controlName]="'trustContactMobile'"
            [placeholderText]="'Phone'"
          ></fmc-sensis-mobile>
        </div>
        <div class="col-sm-3">
          <fmc-sensis-email
              [parentFormGroup]="trust"
              [controlName]="'trustContactEmail'"
              [placeholderText]="'Email'"
          ></fmc-sensis-email>
        </div>
        <div [ngClass]="{'hide-block':selectedContacts?.indexOf('trust-' + i) >= 0}">
          <div class="col-sm-12" *ngFor="let contact of contactList">
            <ng-container *ngIf="contact?.contactName && contact?.identity !== 'trust-' + i && !contact.isDisabled">
              <mat-checkbox (change)="setContact($event, trust, contact, i)" [checked]="trust.value?.contactSelected === contact?.identity">
                Same contact as <span class="text-capitalize">{{ contact?.companyTrustName }}</span>
              </mat-checkbox>
            </ng-container>
          </div>
        </div>
      </div>

      <mat-card>
        <mat-card-content>
          <div class="row">
            <div class="col-sm-12">
              <h4>Address details</h4>
            </div>
            <div class="col-sm-8">
              <app-address-suggestions
              [formGroup]="trust"
              [control]="'tradingAddress'"
              ></app-address-suggestions>
              <fmc-address-search
              [mode]="'external'"
              [parentFormGroup]="trust"
              [controlName]="'tradingAddress'"
              [placeholderText]="'Trading address'"
              [toggleResetFormValues]="false"
              ></fmc-address-search>
            </div>
         </div>
         <div class="row">
            <div class="col-sm-8" *ngIf="!trust.value.postalAddressAsTrading">
              <fmc-address-search
                  [mode]="'external'"
                  [parentFormGroup]="trust"
                  [controlName]="'postalAddress'"
                  [placeholderText]="'Postal address'"
                  [toggleResetFormValues]="false"
              ></fmc-address-search>
            </div>
            <div class="col-sm-12">
              <mat-checkbox formControlName="postalAddressAsTrading" (change)="addressAsAbove(i, 'postalAddress', trust.value)">
                Postal address same as trading
              </mat-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8" *ngIf="!trust.value.postSettlementAddressAsTrading">
              <fmc-address-search
                  [mode]="'external'"
                  [parentFormGroup]="trust"
                  [controlName]="'postSettlementAddress'"
                  [placeholderText]="'Address after settlement'"
                  [toggleResetFormValues]="false"
              ></fmc-address-search>
            </div>
            <div class="col-sm-12">
              <mat-checkbox formControlName="postSettlementAddressAsTrading" (change)="addressAsAbove(i, 'postSettlementAddress', trust.value)">
                Address after settlement same as trading
              </mat-checkbox>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
</ng-container>
